import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import ucarStorage from '../utils/storage'
const baseURL = ''
// 当前进行中的请求个数
let requestCount = 0

class CError extends Error {
  constructor(message, status) {
    super(message)
    this.cStatus = status
  }
}

const logout = () => {
  ucarStorage.removeSession('ucar-login-status')
  location.hash = `#${ucarStorage.getSession('index-url') || '/'}`
}

axios.interceptors.response.use(
  config => config,
  error => {
    return Promise.reject(new CError('系统繁忙', error.response ? error.response.status : 500))
  }
)

const isSuccess = data => {
  if (data && (data.code === 1 || !data.code)) {
    return true
  }

  return false
}

const request = (url, data, options, displayToast, displayLoading) => {
  const config = {
    url,
    timeout: 15000,
    ...options,
  }
  if (/get|head/i.test(config.method)) {
    config.params = data
  } else {
    config.data = data
  }
  Vue.prototype.$loading.show()
  requestCount++

  return axios(config)
    .then(res => {
      const { data } = res
      try {
        if (!isSuccess(data)) {
          let error = null
          const { code, msg } = data
          if (code === 5) {
            error = new CError('登录超时，请重新登录', 401)
          } else {
            error = new CError(msg || '系统繁忙', 500)
          }
          return Promise.reject(error)
        }
      } catch (error) {
        return Promise.reject(error)
      }
      if (data.content) {
        data.re = data.content
      }
      requestCount--
      if (requestCount === 0 && displayLoading) {
        Vue.prototype.$loading.hidden()
      }
      return Promise.resolve(data && data.re ? data.re : data)
    })
    .catch(error => {
      requestCount--
      if (requestCount === 0) {
        Vue.prototype.$loading.hidden()
      }
      const { cStatus, message } = error
      if (cStatus === 401) logout()
      if (displayToast) Vue.prototype.$alert(message)
      return Promise.reject(error)
    })
}

const post = (url, data, options, displayToast, displayLoading) => {
  const config = {
    baseURL,
    method: 'post',
    withCredentials: true,
    ...options,
  }
  return request(url, data, config, displayToast, displayLoading)
}

const get = (url, data, options, displayToast, displayLoading) => {
  return request(
    url,
    data,
    {
      baseURL,
      method: 'get',
      withCredentials: true,
      ...options,
    },
    displayToast,
    displayLoading
  )
}

export default function(Vue) {
  Object.defineProperty(Vue.prototype, '$post', {
    value(url, data, options, displayToast = true, displayLoading = true) {
      return post(url, data, options, displayToast, displayLoading)
    },
  })
  Object.defineProperty(Vue.prototype, '$get', {
    value(url, data, options, displayToast = true, displayLoading = true) {
      return get(url, data, options, displayToast, displayLoading)
    },
  })
  Object.defineProperty(Vue.prototype, '$gw', {
    value(uri, data, displayToast = true, displayLoading = true) {
      let reqUrl = '/api/gw'
      let reqData

      // 处理formdata逻辑
      if (data && data instanceof FormData) {
        reqUrl += '?' + qs.stringify({ uri, origin: 'newDwap' })
        reqData = data
      } else {
        let imgData = ''
        if (data && data.imgData) {
          imgData = data.imgData
          delete data.imgData
        }
        const body = {
          uri,
          data: JSON.stringify(data),
          origin: 'newDwap',
        }
        if (imgData) body.imgData = imgData
        reqData = qs.stringify(body)
      }

      return post(reqUrl, reqData, {}, displayToast, displayLoading)
    },
  })
}
